if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* ===== Color-grouped product gallery (matches image alt text to the selected Color option) ===== */
(function(){
  function initColorMediaGrouping(){
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    var viewerList = viewer.querySelector('.product__media-list') || viewer.querySelector('ul');
    if (!viewerList) return;
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    var thumbList = thumbs ? (thumbs.querySelector('.thumbnail-list') || thumbs.querySelector('ul')) : null;
    var timer = null, observing = false;
    var obs = new MutationObserver(function(){ schedule(); });

    function selectedColor(){
      var el = document.querySelector('input[name="Color"]:checked') || document.querySelector('select[name="Color"]');
      return el ? String(el.value || '').trim().toLowerCase() : '';
    }
    function altOf(el){ var i = el.querySelector('img'); return i ? String(i.getAttribute('alt') || '').trim().toLowerCase() : ''; }

    function doReorder(){
      var color = selectedColor(); if (!color) return;
      var items = [].slice.call(viewerList.querySelectorAll('.product__media-item'));
      if (!items.length) return;
      var match = items.filter(function(it){ return altOf(it) === color; });
      if (!match.length) return;
      var already = items.slice(0, match.length).every(function(it){ return altOf(it) === color; });
      if (already) return;
      var rest = items.filter(function(it){ return altOf(it) !== color; });
      var colorByTarget = {};
      items.forEach(function(it){ colorByTarget[it.getAttribute('data-media-id')] = altOf(it); });
      match.concat(rest).forEach(function(it){ viewerList.appendChild(it); });
      if (thumbList){
        var titems = [].slice.call(thumbList.querySelectorAll('.thumbnail-list__item'));
        if (titems.length){
          var tmatch = titems.filter(function(tt){ return colorByTarget[tt.getAttribute('data-target')] === color; });
          var trest = titems.filter(function(tt){ return colorByTarget[tt.getAttribute('data-target')] !== color; });
          if (tmatch.length) tmatch.concat(trest).forEach(function(tt){ thumbList.appendChild(tt); });
        }
      }
      try { if (typeof viewer.resetPages === 'function') viewer.resetPages(); } catch(e){}
      try { if (thumbs && typeof thumbs.resetPages === 'function') thumbs.resetPages(); } catch(e){}
      try { if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(match[0].getAttribute('data-media-id'), false); } catch(e){}
    }

    function runReorder(){
      obs.disconnect(); observing = false;
      try { doReorder(); } catch(e){}
      requestAnimationFrame(startObserving);
    }
    function schedule(){ clearTimeout(timer); timer = setTimeout(runReorder, 120); }
    function startObserving(){ if (observing) return; try { obs.observe(viewerList, { childList: true }); observing = true; } catch(e){} }

    document.addEventListener('change', function(e){ if (e.target && e.target.name === 'Color') schedule(); });
    startObserving();
    setTimeout(runReorder, 250);
  }
  if (document.readyState !== 'loading') initColorMediaGrouping();
  else document.addEventListener('DOMContentLoaded', initColorMediaGrouping);
})();
